module.exports = __webpack_public_path__ + "static/media/Female06.16957695.jpg";